import "../../common/prefixName.js"
var apiBaseUrl = Link.prefix.realmName;

// config ---------------------------------------------------//

var config = {
    apiConfig : {
        checkAd : {
            url : apiBaseUrl + 'portal/advertis/getAdvertisByType'
        }
    }
};

// end config ------------------------------------------------ //

export default {

    load : function (params, callback, errorHandler) {

        log('load ad. params: ');
        log(params);

        var me = this;

        $.ajax({
            url : config.apiConfig.checkAd.url,
            type : config.apiConfig.checkAd.method || 'get',
            data : params,
            success : function (result) {

                if (result.errorCode)
                {
                    errorHandler ? errorHandler(result) : null;
                    return;
                }

                callback ? callback(result) : null;

            },
            error : app.config.ajaxErrorHandle
        });
    }
};



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/lib/util/ad.js
 **/